import React from 'react'
import { Slider } from 'antd';

const onChange = (value) => {
    console.log('onChange: ', value);
  };
  
  const onAfterChange = (value) => {
    console.log('onAfterChange: ', value);
  };
  const marks = {
   0: '5',
   5:  '6',
   10: '7'
  
   
  };

const rangeSlider = () => {
  return (
    <>
    <Slider marks={marks } min={0} max={10}  onChange={onChange} onAfterChange={onAfterChange} />
   
  </>
  )
}

export default rangeSlider